import { login, logout, getCurrentUser } from '../../util/APIUtils';
import { getToken, setToken, removeToken, setOpenId ,
  getOpenId, removeOpenId, removeTestId, removeGameId,
  // 父域名
  getParentOpenId,} from '../../util/auth';

const user = {
  state: {
    token: getToken(),
    name: '',
    email: '',
    avatar: '',
    userId: '',
	  signature: '',
    emailVerified: false,
    country: '',
    receiveNews: false,
    receivePost: false,
    receiveComment: false,
    receiveActivity: false,
    receiveLike: false,
    receiveGrowthTask: false,
    receiveRecommendFriend:false,
    receiveChatReminder:false,
    receiveUserTest:false,
    useTranslator: false,
    blacklist: false,
    provider:'',
    openId: getParentOpenId() || '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_SIGNATURE: (state, signature) => {
      state.signature = signature;
    },
    SET_EMAIL: (state, email) => {
      state.email = email;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_USERID: (state, userId) => {
      state.userId = userId;
    },
    SET_EMAILVERIFIED: (state, emailVerified) => {
      state.emailVerified = emailVerified;
    },
    SET_COUNTRY: (state, country) => {
      state.country = country;
    },
    SET_RECEIVENEWS: (state, receiveNews) => {
      state.receiveNews = receiveNews;
    },
    SET_RECEIVEPOST: (state, receivePost) => {
      state.receivePost = receivePost;
    },
    SET_RECEIVERECOMMENDFRIEND: (state, receiveRecommendFriend) => {
      state.receiveRecommendFriend = receiveRecommendFriend;
    },
    SET_RECEIVECHATRECOMMEND: (state, receiveChatReminder) => {
      state.receiveChatReminder = receiveChatReminder;
    },
    SET_RECEIVECOMMENT: (state, receiveComment) => {
      state.receiveComment = receiveComment;
    },
    SET_RECEIVEACTIVITY: (state, receiveActivity) => {
      state.receiveActivity = receiveActivity;
    },
    SET_RECEIVELIKE: (state, receiveLike) => {
      state.receiveLike = receiveLike;
    },
    SET_RECEIVEGROWTHTASK: (state, receiveGrowthTask) => {
      state.receiveGrowthTask = receiveGrowthTask;
    },
    SET_RECEIVEUSERTEST: (state, RECEIVEUSERTEST) => {
      state.receiveUserTest = RECEIVEUSERTEST;
    },
    SET_USETRANSLATOR: (state, USETRANSLATOR) => {
      state.useTranslator = USETRANSLATOR;
    },
    SET_BLACKLIST: (state, blacklist) => {
      state.blacklist = blacklist;
    },
    SET_PROVODER: (state, provider) => {
      state.provider = provider;
    },
    SET_OPENID: (state, openId) => {
      state.openId = openId;
    },
  },

  actions: {
    // user login
    login({commit}, userInfo) {
      commit('SET_TOKEN', '');
      removeToken();
      const {email, password} = userInfo;
      return new Promise((resolve, reject) => {
        login({email: email.trim(), password: password}).then(response => {
          try{
            let accessToken = response.data.token.accessToken;
            let tokenType = response.data.token.tokenType;
            commit('SET_TOKEN', accessToken);

            setToken(tokenType + ' ' + accessToken);
            resolve(response);
            // return response;
          }catch (e) {
            // 非401 未授权 返回到业务层处理
            resolve(response);
            // console.log(response)
            // return response
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    signupWithToken({commit}, res) {
      let accessToken = res.data.token.accessToken;
      let tokenType = res.data.token.tokenType;
      commit('SET_TOKEN', accessToken);
      setToken(tokenType + ' ' + accessToken);
    },
    // get user info
    getInfo({commit, state}) {
      return new Promise((resolve, reject) => {
        getCurrentUser().then(response => {
          const {data, code} = response;
          if (code !== 0) {
            reject('Verification failed, please Login again.');
          }
          const {id, name, signature, email, imageUrl, emailVerified,
            country,receiveNews,blacklist, provider, openId,
            receivePost, receiveComment, receiveActivity,receiveRecommendFriend,receiveChatReminder,
            receiveLike, receiveGrowthTask,receiveUserTest,useTranslator, fbTwEmail} = data;
          // console.log('imageUrl', imageUrl)
          commit('SET_USERID', id);
          commit('SET_SIGNATURE', signature);
          commit('SET_NAME', name);
          if ((email.startsWith('for_example_abcuser..') && email.endsWith('@xx.com'))) {
            commit('SET_EMAIL', fbTwEmail);
          }else{
            commit('SET_EMAIL', email);
          }

          commit('SET_AVATAR', imageUrl);
          commit('SET_EMAILVERIFIED', emailVerified);
          commit('SET_COUNTRY', country);
          commit('SET_RECEIVENEWS', receiveNews);
          commit('SET_BLACKLIST', blacklist);
          commit('SET_PROVODER', provider);

          commit('SET_OPENID', openId);
          commit('SET_RECEIVEPOST', receivePost);
          commit('SET_RECEIVERECOMMENDFRIEND', receiveRecommendFriend);
          commit('SET_RECEIVECHATRECOMMEND', receiveChatReminder);
          commit('SET_RECEIVECOMMENT', receiveComment);
          commit('SET_RECEIVEACTIVITY', receiveActivity);
          commit('SET_RECEIVELIKE', receiveLike);
          commit('SET_RECEIVEGROWTHTASK', receiveGrowthTask);
          commit('SET_RECEIVEUSERTEST',receiveUserTest);
          commit("SET_USETRANSLATOR", useTranslator);
          setOpenId(openId);

          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // user logout
    logout({commit, state}) {
      return new Promise((resolve, reject) => {
        logout().then(() => {

          commit('SET_TOKEN', '');
          commit('SET_USERID', '');
          commit('SET_NAME', '');
          commit('SET_EMAIL', '');
          commit('SET_AVATAR', '');
          commit('SET_EMAILVERIFIED', false);
          commit('SET_COUNTRY', '');
          commit('SET_RECEIVENEWS', false);
          commit('SET_BLACKLIST', false);
          commit('SET_PROVODER', '');
          commit('SET_OPENID', '');
          removeOpenId();
          removeToken();
          removeTestId();
          removeGameId();

          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },

    // remove token
    resetToken({commit}) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        removeToken();
        resolve();
      });
    }
  }
};

export default user;
